import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import type { Activity } from '../types';
import { Avatar } from '../components/Avatar';
import { timeAgo } from '../format';

const TEXT: Record<Activity['kind'], string> = { like: 'gave you a thumbs up 👍', interest: "wants to jam with you 🤘", follow: 'started following you' };

export function FeedPage() {
  const [items, setItems] = useState<Activity[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.feed().then((r) => { setItems(r.activities); if (r.unread > 0) api.feedSeen().catch(() => {}); }).catch((e) => setError(e.message));
  }, []);

  if (error) return <div className="error">{error}</div>;
  if (items === null) return <div className="spinner">Loading…</div>;
  if (items.length === 0) return <div className="empty">Nothing yet. When someone gives you a thumbs up, follows you, or wants to jam, it shows up here.</div>;

  return (
    <div className="card">
      {items.map((a) => (
        <Link to={`/users/${a.actor.id}`} key={a.id} className="list-item" style={{ color: 'inherit' }}>
          <Avatar url={a.actor.photoUrl} name={a.actor.displayName} size="sm" />
          <div className="body">
            <div><strong>{a.actor.displayName}</strong> {TEXT[a.kind]}</div>
            <div className="muted small">{timeAgo(a.createdAt)}</div>
          </div>
        </Link>
      ))}
    </div>
  );
}
